import { useState, useCallback, useEffect } from "react";

export default function usePreviewDocument(promise) {
  const [state, setState] = useState(new Map());
  const [error, setError] = useState(new Map());

  const updateState = useCallback((id, isLoading) => {
    setState((prev) => new Map(prev).set(id, isLoading));
  }, []);

  const updateError = useCallback((id, err) => {
    setError((prev) => new Map(prev).set(id, err));
  }, []);

  const preview = useCallback(
    async (id) => {
      updateError(id, null);
      updateState(id, true);

      try {
        const result = await promise(id);

        let blob;
        if (result && typeof result === "object" && "data" in result) {
          blob = result.data;
        } else {
          blob = result;
        }

        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      } catch (err) {
        updateError(id, true);
      } finally {
        updateState(id, false);
      }
    },
    [promise, updateError, updateState]
  );

  useEffect(() => {
    return () => {
      setState(new Map());
      setError(new Map());
    };
  }, []);

  return [{ state, error }, preview];
}
